<div class="server-request-status-indicator">
	<span class="material-symbols-outlined server-request-rejected">sync_disabled</span>
</div>